






















































































































































































































import { getToken, getUserStatus } from '@/utils/cookie';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import UserStore, { UserStoreInterface } from '@/resource/user/user.store';
import BeatLoader from 'vue-spinner/src/BeatLoader.vue';
import MainTitle from '@/components/common/MainTitle.vue';
import { UserStatus } from '@/resource/user/user.model';
import Icon from '@/main-components/common/Icon.vue';

@Component({
  components: {
    BeatLoader,
    MainTitle,
    Icon,
  },
})
export default class Header extends Vue {
  headerId = 'MAIN_HEADER';
  userStore: UserStoreInterface = UserStore;

  @Prop({ default: false })
  showMenuByParent: boolean;

  isLoading = false;

  showMenu = false;

  get currentPage() {
    return this.$route.name;
  }

  get isPremium() {
    return this.userStatus === UserStatus.Premium;
  }

  userStatus: UserStatus = getUserStatus() || UserStatus.Free;

  isLoggedin = false;

  mainClass = 'sm:bg-white-100';

  active = 'mt-1 border-b-1 border-solid border-red-100 inline-block';
  notActive =
    'mt-1 border-b-1 border-solid border-white-100 inline-block hover:text-gray-200';

  redButton =
    'text-red-100 border-1 border-solid border-red-100 rounded-DEFAULT';

  links = [
    {
      name: 'Set Latihan',
      class: this.notActive,
      path: '/browse',
      isPrivate: true,
      isPublicOnly: true,
    },
    {
      name: 'Bina Latihan',
      class: this.notActive,
      path: '/papers',
      isPrivate: true,
      isPublicOnly: true,
    },
    {
      name: 'Harga',
      class: this.notActive,
      path: '/pricing',
      isPrivate: true,
      isPublicOnly: true,
      isHideOnPremium: true,
    },
    {
      name: 'Program Affiliate',
      class: this.notActive,
      path: '/program-affiliate',
      isPrivate: true,
      isPublicOnly: false,
    },
    // {
    //   name: 'Koleksi',
    //   class: this.notActive,
    //   path: '/folders',
    //   isPrivate: true,
    //   isPublicOnly: true,
    // },
    {
      name: 'Blog',
      class: this.notActive,
      path: '/blog',
      isPrivate: true,
      isPublicOnly: true,
    },
    {
      name: 'Pembelian Saya',
      class: this.notActive,
      path: '/purchases',
      isPrivate: true,
      isPublicOnly: false,
    },
    {
      name: 'Daftar Masuk',
      class: this.notActive,
      path: '/signin',
      isPrivate: false,
      isPublicOnly: true,
    },
  ];

  created() {
    if (this.showMenuByParent) {
      this.showMenu = true;
    }

    this.isLoggedin = getToken() ? true : false;
    if (this.currentPage) {
      this.updateLink(this.currentPage);
    }
  }

  @Watch('currentPage')
  onPageChanged() {
    this.isLoggedin = getToken() ? true : false;
    this.userStatus = getUserStatus() || UserStatus.Free;

    if (this.currentPage) {
      this.updateLink(this.currentPage);
    }
  }

  updateLink(path: string) {
    this.links = this.links.map(link => {
      const availLink = link.path.replace('/', '');
      if (availLink === path) {
        link.class = this.active;
      } else {
        link.class = this.notActive;
      }

      return link;
    });
  }

  signupClick() {
    this.$router.push({
      path: '/signup',
    });
  }

  async signOutClicked() {
    if (this.isLoading) return;
    this.isLoading = true;

    await this.userStore.signout();

    if (this.$router.currentRoute.name === 'home') {
      this.$router.go(0);
    } else {
      this.$router.push({
        name: 'home',
      });
    }
    this.isLoading = false;
  }

  menuClicked() {
    this.showMenu = true;
    this.$emit('updateShowMenu', true);
  }

  linkClicked() {
    this.showMenu = false;
  }

  closeClicked() {
    this.showMenu = false;
    this.$emit('updateShowMenu', false);
  }
}
